import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import { adminSections } from './adminSections';

interface Props { activeTab: string; onTabChange: (tab: string) => void; }
export default function AdminNavigation({ activeTab, onTabChange }: Props) {
  const { t } = useTranslation('admin');
  return <nav className="wh-workspace-nav" aria-label={t("admin:studio.navigation", { defaultValue: 'Dojo administration' })}>
    {adminSections.map(item => <Button key={item.value} variant="ghost" onClick={() => onTabChange(item.value)} aria-pressed={activeTab === item.value} aria-controls="admin-workspace-panel" className="gap-2 px-3 text-xs sm:text-sm">
      <item.icon className="h-4 w-4" /><span>{t(item.key, { defaultValue: item.fallback })}</span>
    </Button>)}
  </nav>;
}
